import { render } from "./CourseSection.vue?vue&type=template&id=2c8d6ab4&scoped=true"
import script from "./CourseSection.vue?vue&type=script&lang=js"
export * from "./CourseSection.vue?vue&type=script&lang=js"

import "./CourseSection.vue?vue&type=style&index=0&id=2c8d6ab4&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8d6ab4"]])

export default __exports__